import * as React from "react";
import * as Styled from "./Contact.style";

const Contact: React.FC<{}> = () => (
  <Styled.Banner
    m="40px auto"
    justifyContent="center"
    alignItems="center"
    flexDirection="column"
  >
    <Styled.Title>Contact us!</Styled.Title>
    <Styled.Paragraph>
      Email:{" "}
      <Styled.Anchor href="mailto:yvonne@suzis-specialties.com">
        yvonne@suzis-specialties.com
      </Styled.Anchor>{" "}
      or{" "}
      <Styled.Anchor href="mailto:arianna@suzis-specialties.com">
        arianna@suzis-specialties.com
      </Styled.Anchor>
    </Styled.Paragraph>
    <Styled.Paragraph>
      Telephone: <Styled.Anchor href="tel:313-682-8064">313-682-8064</Styled.Anchor>
    </Styled.Paragraph>
  </Styled.Banner>
);

export default Contact;
